export default "__VITE_ASSET__PTW3t5hq__"